// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2iO-x","card":"styles_card__2Hnry","overlay":"styles_overlay__1fqpC"};